<template>
  <div>
    <h1>Sidan hittades inte</h1>

    <p>
      <a href="/">Gå till startsidan</a>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'

  div
    width: 100%
    padding: 4rem
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

  h1
    @extend .t-header
    text-align: center

  a
    color: $red
</style>
